import styled from "styled-components";

export const CVEditListStyles = styled.div`
  &.cve-list {
    display: flex;
    flex-direction: column;

    &.cve-list.cve-list.cve-list {
      margin-top: 1rem;
    }

    // responsive start

    &.cve-s {
      .cve-listing {
        flex-direction: column;
        margin: 0.75rem 0;
      }

      .cve-listing-left {
        margin-right: 0;
        padding-right: 0;
        border-right: 0;
        flex-basis: auto;
      }

      .cve-left-dates .cve-listing-text {
        display: inline;
      }

      .cve-left-dates {
        font-weight: bold;
        font-size: 0.75em;
        color: var(--text-color-secondary);
      }
    }

    // responsive end

    .cve-header.cve-header.cve-header {
      margin-top: 0.25rem;
      margin-bottom: 0.5rem;
    }

    &:not(:first-child) {
      > .cve-header.cve-header.cve-header {
        margin-top: 2.575rem;
      }
    }

    .cve-listing-deleted.cve-listing-deleted {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;

      .p-inline-message {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-top: 0;
        padding-bottom: 0;
        padding-right: 0;
        z-index: 1;
      }

      .p-button {
        color: inherit;
      }
    }

    .cve-listing-text {
      overflow: hidden;
    }

    .cve-listing {
      margin: 1.5rem 0;
      display: flex;
      position: relative;

      &.cve-listing-deleted {
        margin: 0.5rem 0;
      }

      &:first-child {
        margin-top: 0.5rem;
      }
      &:last-child {
        margin-bottom: 0.5rem;
      }
    }

    .cve-listing-left {
      border-right: 1px solid var(--surface-300);
      padding-right: 1rem;
      margin-right: 1rem;
      flex-basis: 100px;
      word-break: break-all;
      flex-shrink: 0;
    }

    .cve-listing-right {
      flex-basis: 70%;
      min-width: 0;
      flex-grow: 1;
    }

    .cve-listing-buttons {
      float: right;
      margin-top: -7px;
    }
  }
`;
